import style from './ArrowSelect.module.css'
import {ReactComponent as Arrow} from '../../Assets/icons/select-icon.svg'
export function ArrowSelect() {
    return <Arrow className={style.arrow}/>
}